import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs';
import {City, CitySearch} from '../models/City';
import { AuthConfig } from '../models/AuthConfig';
import { environment } from '../../environments/environment';
import { Page, PageQueryParams } from '../models/Pageable';

@Injectable({
  providedIn: 'root'
})
export class MunicipiosService {
  private municipioSelecionado?: string;

  private readonly API = `${environment.api.url}/api/v1/municipios`;

  constructor(private http: HttpClient) {}

  setMunicipioSelecionado(municipioSelecionado: string) {
    this.municipioSelecionado = municipioSelecionado;
  }

  getMunicipioSelecionado() {
    return this.municipioSelecionado;
  }

  getCityByUfAndName(name: string, uf: string) {
    return this.http.get(`${this.API}/${uf}/${name}`);
  }

  listCitiesByState(uf: string, params: PageQueryParams): Observable<Page<City>> {
    const queryParams = new HttpParams({
      fromObject: {
        offset: params.offset.toString(),
        limit: params.limit.toString(),
        filter: params.filter,
        sort: params.sort
      }
    });
    return this.http.get<Page<City>>(`${this.API}/${uf}/`, { params: queryParams });
  }

  findByUfAndQuerySearch(uf: string, query: string, offset: number, limit: number): Observable<Page<City>> {
    const queryParams = new HttpParams({
      fromObject: {
        offset,
        limit
      }
    })

    return this.http.get<Page<City>>(`${this.API}/search/${uf}/${query}`, { params: queryParams });
  }

  getBrasaoUrl(uf?: string, codigoIbge?: number): Observable<any> {
    return this.http.get(`${this.API}/${uf}/${codigoIbge}/brasao/url`);
  }

  getBrasaoFromUrl(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: "blob" });
  }

  getDadosMunicipio(uf?: string, codigoIbge?: number) {
    return this.http.get(`${this.API}/${uf}/${codigoIbge}/dados`);
  }

  getMunicipalities(uf: string,  params: PageQueryParams) {
    const queryParams = new HttpParams({
      fromObject: {
        offset: params.offset.toString(),
        limit: params.limit.toString(),
        filter: params.filter,
        sort: params.sort
      }
    });

    return this.http.get<Page<City>>(`${this.API}/${uf}`, { params: queryParams });
  }

  getAuthConfig(uf: string, municipio: string): Observable<AuthConfig> {
    return this.http.get<AuthConfig>(`${this.API}/${uf}/${municipio}/auth-config`);
  }

  getGovBrConfig(uf: string,
                 municipio: string): Observable<{ encryptedGovBrConfig?: string | null }> {
    return this.http.get<{ encryptedGovBrConfig?: string | null }>(
      `${this.API}/${uf}/${municipio}/govbr-config`
    );
  }
}
